import _ from 'lodash';

const initialState = {
	postLoginSearchKeyword: "",
	productNumberList: null,
	isValidProductNumber: true,
	showSuggestion: false
};

export default function searchKeyword(state = initialState, action) {
    switch (action.type) {
	    case 'SAVE_POST_LOGIN_SEARCH_KEYWORD':
	        return { ...state,
	            postLoginSearchKeyword: action.data
	        };
		case 'RESET_SEARCH_KEYWORD_SUGGESTION_LIST':
	        return { ...state,
	            productNumberList: null,
	            isValidProductNumber: true,
	            showSuggestion: false
	        };
		case 'SAVE_SEARCH_KEYWORD_SUGGESTION_LIST':
			// var productNumberList = action.data?action.data:[];
			const data = action.data ? _.sortBy(action.data, 'sku') : action.data;
	        return { ...state,
	            productNumberList: data,
	            isValidProductNumber: (action.data && action.data.length > 0 ? true : false)
	        };
		case 'RESET_SEARCH_KEYWORD_REDUCERS':
			return initialState;
	    default:
	        return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/searchKeyword.js